import { localisedValue } from "utils"

const commonTransformFunction = (data = [], stage) => {
  return data?.map(item => {
    const lead = item?.Lead
    const taxResidencyCountryId = lead?.profilingFields?.taxResidency ?? lead?.taxResidency
    const clientCountry = lead?.Client?.Country

    return {
      ...item,
      clientId: lead?.Client?.id || item?.clientId,
      taxResidencyCountryId,
      pipelineClientCountryLocCode: clientCountry?.locCode,
      pipelineClientCountryTitle: localisedValue({ object: clientCountry, key: "name" }),
      title: localisedValue({ object: item, key: "projectName" }),
      price: item?.potentialRevenue,
      apartment: localisedValue({ object: item, key: "listingUnitNumber" }),
      leadId: item?.inquiryId ||item?.leadId,
      leadName: localisedValue({ object: item, key: "clientName" }),
      agentImage: item?.userProfilePicture,
      calls: item?.numberOfPhoneCalls || item?.callCount,
      meeting: item?.numberOfMeetingsDone || item?.meetingCount,
      date: item?.date,
      percentage: item?.conversionProbability || item?.probabilityManual,
      aiPercentage: item?.aiClosureProbability,
      totalRevenue: item?.totalRevenue ?? 0,
      totalPotentialRevenue: item?.totalPotentialRevenue ?? 0,
      totalReportedRevenue: item?.totalReportedRevenue ?? 0,
      totalRecognizedRevenue: item?.totalRecognizedRevenue ?? 0,
      stage,
    }
  })
}

export const salesPipelineDataTransformer = (response = {}, args = {}) => {
  const stages = Object.keys(response).filter(
    key => typeof response?.[key] === "object" && !Array.isArray(response?.[key])
  )

  let hasLoadMore = false

  const transformedData = stages.reduce(
    (acc, stage) => {
      const stageData = response?.[stage] || {}

      const loadMore = stageData?.count > args?.pageLimit * (args?.pageIndex + 1)

      if (loadMore) {
        hasLoadMore = true
      }

      acc[stage] = {
        ...stageData,
        data: commonTransformFunction(stageData?.data, stage),
        loadMore,
        totalRevenue: stageData?.totalRevenue ?? 0,
        totalPotentialRevenue: stageData?.totalPotentialRevenue ?? 0,
        totalReportedRevenue: stageData?.totalReportedRevenue ?? 0,
        totalRecognizedRevenue: stageData?.totalRecognizedRevenue ?? 0,
      }

      return acc
    },
    {
      max: Math.max(...stages.map(stage => response?.[stage]?.count || 0)),
    }
  )

  transformedData.loadMore = hasLoadMore

  return {
    [args.pageIndex]: transformedData,
  }
}
